<div id="overlay" class="d-flex justify-content-center d-none" #loadingContainer>
    <div class="spinner-border content" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>